import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import { contactPageTplData } from "../data/page-tpl-contact.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import PageHead from "../components/Page/PageHead";
import Locations from "../components/Locations";
import GetInTouch from "../components/GetInTouch";
import { VectorBackground } from "../components/VectorBackground";

const pageContact = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = contactPageTplData(id);

    return (
        <Layout
            pageTitle={seoPageData.title}
            navbarVariant="white"
            backgroundVariant="deepblue"
            hideNavbarButton
            hideBanner
            fullWidth
        >
            {/* SEO Metas */}
            <Seo post={seoPageData} />

            <div className="contact-page-content">
                <VectorBackground />

                {/* Page head */}
                <Container>
                    <PageHead
                        specialStylingForRequestDemoPage={true}
                        variant="white"
                        title={pageData.pageHeader.header}
                        text={pageData.pageHeader.text}
                    />
                </Container>

                {/* Resources Section */}
                <Section className="-small-margin-bottom">
                    <Container>
                        <Locations locations={pageData.contacts} />
                    </Container>
                </Section>
            </div>

            {/* GetInTouch Section */}
            {/* <Section className="-mobile-full">
                <GetInTouch pageTitle={seoPageData.title} />
            </Section>

            <PageFooterSections pageData={pageData} /> */}
        </Layout>
    );
};

export default pageContact;
